.button,
.iconButton {
  --md-sys-color-primary: var(--pgm-sys-color-primary);
  --md-sys-color-on-primary: var(--pgm-sys-color-on-primary);
  --md-sys-color-secondary: var(--pgm-sys-color-secondary);
  --md-sys-color-secondary-container: var(--pgm-sys-color-secondary-container);
  --md-sys-color-on-secondary-container: var(--pgm-sys-color-on-secondary-container);
  --md-sys-color-surface-container-low: var(--pgm-sys-color-surface-container-low);
  --md-sys-color-on-surface: var(--pgm-sys-color-on-surface);
  --md-sys-color-on-surface-variant: var(--pgm-sys-color-on-surface-variant);
  --md-sys-color-outline-variant: var(--pgm-sys-color-outline-variant);
  --md-sys-color-shadow: var(--pgm-sys-color-shadow);
}

.button {
  --pgm-button-shape-round: 9999px;
  --md-elevated-button-container-height: var(--pgm-button-container-height);
  --md-elevated-button-icon-size: var(--pgm-button-icon-size);
  --md-elevated-button-label-text-font: var(--pgm-button-label-font);
  --md-elevated-button-label-text-line-height: var(--pgm-button-label-line-height);
  --md-elevated-button-label-text-size: var(--pgm-button-label-size);
  --md-elevated-button-label-text-weight: var(--pgm-button-label-weight);
  --md-elevated-button-pressed-state-layer-opacity: 0.1;
  --md-filled-button-container-height: var(--pgm-button-container-height);
  --md-filled-button-icon-size: var(--pgm-button-icon-size);
  --md-filled-button-label-text-font: var(--pgm-button-label-font);
  --md-filled-button-label-text-line-height: var(--pgm-button-label-line-height);
  --md-filled-button-label-text-size: var(--pgm-button-label-size);
  --md-filled-button-label-text-weight: var(--pgm-button-label-weight);
  --md-filled-button-pressed-state-layer-opacity: 0.1;
  --md-filled-tonal-button-container-height: var(--pgm-button-container-height);
  --md-filled-tonal-button-icon-size: var(--pgm-button-icon-size);
  --md-filled-tonal-button-label-text-font: var(--pgm-button-label-font);
  --md-filled-tonal-button-label-text-line-height: var(--pgm-button-label-line-height);
  --md-filled-tonal-button-label-text-size: var(--pgm-button-label-size);
  --md-filled-tonal-button-label-text-weight: var(--pgm-button-label-weight);
  --md-filled-tonal-button-pressed-state-layer-opacity: 0.1;
  --md-outlined-button-container-height: var(--pgm-button-container-height);
  --md-outlined-button-icon-size: var(--pgm-button-icon-size);
  --md-outlined-button-label-text-font: var(--pgm-button-label-font);
  --md-outlined-button-label-text-line-height: var(--pgm-button-label-line-height);
  --md-outlined-button-label-text-size: var(--pgm-button-label-size);
  --md-outlined-button-label-text-weight: var(--pgm-button-label-weight);
  --md-outlined-button-outline-width: var(--pgm-button-outline-width);
  --md-outlined-button-pressed-state-layer-opacity: 0.1;
  --md-text-button-container-height: var(--pgm-button-container-height);
  --md-text-button-icon-size: var(--pgm-button-icon-size);
  --md-text-button-label-text-font: var(--pgm-button-label-font);
  --md-text-button-label-text-line-height: var(--pgm-button-label-line-height);
  --md-text-button-label-text-size: var(--pgm-button-label-size);
  --md-text-button-label-text-weight: var(--pgm-button-label-weight);
  --md-text-button-pressed-state-layer-opacity: 0.1;
  --md-focus-ring-active-width: 3px;
  --md-focus-ring-color: var(--pgm-sys-color-secondary);
  --md-focus-ring-duration: 0ms;
  --md-focus-ring-width: 3px;
  --pgm-button-focus-horizontal-offset: 6px;

  display: inline-flex;
  font-family: var(--pgm-button-label-font);
  gap: var(--pgm-button-icon-label-space);
  letter-spacing: var(--pgm-button-label-tracking);
  vertical-align: middle;
}

.buttonFullWidth {
  width: 100%;
}

.buttonRound {
  --md-focus-ring-outward-offset: 6px;
  --md-elevated-button-container-shape: var(--pgm-button-shape-round);
  --md-filled-button-container-shape: var(--pgm-button-shape-round);
  --md-filled-tonal-button-container-shape: var(--pgm-button-shape-round);
  --md-outlined-button-container-shape: var(--pgm-button-shape-round);
  --md-text-button-container-shape: var(--pgm-button-shape-round);
}

.buttonSquare {
  --md-focus-ring-outward-offset: 4px;
  --md-elevated-button-container-shape: var(--pgm-button-square-shape);
  --md-filled-button-container-shape: var(--pgm-button-square-shape);
  --md-filled-tonal-button-container-shape: var(--pgm-button-square-shape);
  --md-outlined-button-container-shape: var(--pgm-button-square-shape);
  --md-text-button-container-shape: var(--pgm-button-square-shape);
}

.button:active:not([disabled]):not([soft-disabled]) {
  --md-elevated-button-container-shape: var(--pgm-button-pressed-shape);
  --md-filled-button-container-shape: var(--pgm-button-pressed-shape);
  --md-filled-tonal-button-container-shape: var(--pgm-button-pressed-shape);
  --md-focus-ring-outward-offset: 4px;
  --md-outlined-button-container-shape: var(--pgm-button-pressed-shape);
  --md-text-button-container-shape: var(--pgm-button-pressed-shape);
}

.button::part(focus-ring) {
  inset-block: calc(0px - var(--pgm-button-focus-vertical-offset));
  inset-inline: calc(0px - var(--pgm-button-focus-horizontal-offset));
}

.buttonExtraSmall {
  --pgm-button-container-height: 32px;
  --pgm-button-icon-size: 20px;
  --pgm-button-icon-label-space: 4px;
  --pgm-button-label-font: var(--pgm-sys-typescale-label-large-font);
  --pgm-button-label-line-height: var(--pgm-sys-typescale-label-large-line-height);
  --pgm-button-label-size: var(--pgm-sys-typescale-label-large-size);
  --pgm-button-label-tracking: var(--pgm-sys-typescale-label-large-tracking);
  --pgm-button-label-weight: var(--pgm-sys-typescale-label-large-weight);
  --pgm-button-leading-space: 12px;
  --pgm-button-outline-width: 1px;
  --pgm-button-pressed-shape: 8px;
  --pgm-button-focus-vertical-offset: 2px;
  --pgm-button-square-shape: 12px;
  --pgm-button-trailing-space: 12px;
}

.buttonIcon {
  font-size: var(--pgm-button-icon-size);
  line-height: 0.885;
}

.buttonExtraSmall .buttonIcon {
  font-size: 20px;
  line-height: 1;
}

.buttonSmall {
  --pgm-button-container-height: 40px;
  --pgm-button-icon-size: var(--pgm-sys-typescale-label-large-line-height);
  --pgm-button-icon-label-space: 8px;
  --pgm-button-label-font: var(--pgm-sys-typescale-label-large-font);
  --pgm-button-label-line-height: var(--pgm-sys-typescale-label-large-line-height);
  --pgm-button-label-size: var(--pgm-sys-typescale-label-large-size);
  --pgm-button-label-tracking: var(--pgm-sys-typescale-label-large-tracking);
  --pgm-button-label-weight: var(--pgm-sys-typescale-label-large-weight);
  --pgm-button-leading-space: 16px;
  --pgm-button-outline-width: 1px;
  --pgm-button-pressed-shape: 8px;
  --pgm-button-focus-vertical-offset: 2px;
  --pgm-button-square-shape: 12px;
  --pgm-button-trailing-space: 16px;
}

.buttonMedium {
  --pgm-button-container-height: 56px;
  --pgm-button-icon-size: var(--pgm-sys-typescale-title-medium-line-height);
  --pgm-button-icon-label-space: 8px;
  --pgm-button-label-font: var(--pgm-sys-typescale-title-medium-font);
  --pgm-button-label-line-height: var(--pgm-sys-typescale-title-medium-line-height);
  --pgm-button-label-size: var(--pgm-sys-typescale-title-medium-size);
  --pgm-button-label-tracking: var(--pgm-sys-typescale-title-medium-tracking);
  --pgm-button-label-weight: var(--pgm-sys-typescale-title-medium-weight);
  --pgm-button-leading-space: 24px;
  --pgm-button-outline-width: 1px;
  --pgm-button-pressed-shape: 12px;
  --pgm-button-focus-vertical-offset: 6px;
  --pgm-button-square-shape: 16px;
  --pgm-button-trailing-space: 24px;
}

.buttonLarge {
  --pgm-button-container-height: 96px;
  --pgm-button-icon-size: var(--pgm-sys-typescale-headline-small-line-height);
  --pgm-button-icon-label-space: 12px;
  --pgm-button-label-font: var(--pgm-sys-typescale-headline-small-font);
  --pgm-button-label-line-height: var(--pgm-sys-typescale-headline-small-line-height);
  --pgm-button-label-size: var(--pgm-sys-typescale-headline-small-size);
  --pgm-button-label-tracking: var(--pgm-sys-typescale-headline-small-tracking);
  --pgm-button-label-weight: var(--pgm-sys-typescale-headline-small-weight);
  --pgm-button-leading-space: 48px;
  --pgm-button-outline-width: 2px;
  --pgm-button-pressed-shape: 16px;
  --pgm-button-focus-vertical-offset: 6px;
  --pgm-button-square-shape: 28px;
  --pgm-button-trailing-space: 48px;
}

.buttonExtraLarge {
  --pgm-button-container-height: 136px;
  --pgm-button-icon-size: var(--pgm-sys-typescale-headline-large-line-height);
  --pgm-button-icon-label-space: 16px;
  --pgm-button-label-font: var(--pgm-sys-typescale-headline-large-font);
  --pgm-button-label-line-height: var(--pgm-sys-typescale-headline-large-line-height);
  --pgm-button-label-size: var(--pgm-sys-typescale-headline-large-size);
  --pgm-button-label-tracking: var(--pgm-sys-typescale-headline-large-tracking);
  --pgm-button-label-weight: var(--pgm-sys-typescale-headline-large-weight);
  --pgm-button-leading-space: 64px;
  --pgm-button-outline-width: 3px;
  --pgm-button-pressed-shape: 16px;
  --pgm-button-focus-vertical-offset: 6px;
  --pgm-button-square-shape: 28px;
  --pgm-button-trailing-space: 64px;
}

.buttonExtraSmall,
.buttonSmall,
.buttonMedium,
.buttonLarge,
.buttonExtraLarge {
  --md-elevated-button-leading-space: var(--pgm-button-leading-space);
  --md-elevated-button-trailing-space: var(--pgm-button-trailing-space);
  --md-elevated-button-with-leading-icon-leading-space: var(--pgm-button-leading-space);
  --md-elevated-button-with-leading-icon-trailing-space: var(--pgm-button-trailing-space);
  --md-elevated-button-with-trailing-icon-leading-space: var(--pgm-button-leading-space);
  --md-elevated-button-with-trailing-icon-trailing-space: var(--pgm-button-trailing-space);
  --md-filled-button-leading-space: var(--pgm-button-leading-space);
  --md-filled-button-trailing-space: var(--pgm-button-trailing-space);
  --md-filled-button-with-leading-icon-leading-space: var(--pgm-button-leading-space);
  --md-filled-button-with-leading-icon-trailing-space: var(--pgm-button-trailing-space);
  --md-filled-button-with-trailing-icon-leading-space: var(--pgm-button-leading-space);
  --md-filled-button-with-trailing-icon-trailing-space: var(--pgm-button-trailing-space);
  --md-filled-tonal-button-leading-space: var(--pgm-button-leading-space);
  --md-filled-tonal-button-trailing-space: var(--pgm-button-trailing-space);
  --md-filled-tonal-button-with-leading-icon-leading-space: var(--pgm-button-leading-space);
  --md-filled-tonal-button-with-leading-icon-trailing-space: var(--pgm-button-trailing-space);
  --md-filled-tonal-button-with-trailing-icon-leading-space: var(--pgm-button-leading-space);
  --md-filled-tonal-button-with-trailing-icon-trailing-space: var(--pgm-button-trailing-space);
  --md-outlined-button-leading-space: var(--pgm-button-leading-space);
  --md-outlined-button-trailing-space: var(--pgm-button-trailing-space);
  --md-outlined-button-with-leading-icon-leading-space: var(--pgm-button-leading-space);
  --md-outlined-button-with-leading-icon-trailing-space: var(--pgm-button-trailing-space);
  --md-outlined-button-with-trailing-icon-leading-space: var(--pgm-button-leading-space);
  --md-outlined-button-with-trailing-icon-trailing-space: var(--pgm-button-trailing-space);
  --md-text-button-leading-space: var(--pgm-button-leading-space);
  --md-text-button-trailing-space: var(--pgm-button-trailing-space);
  --md-text-button-with-leading-icon-leading-space: var(--pgm-button-leading-space);
  --md-text-button-with-leading-icon-trailing-space: var(--pgm-button-trailing-space);
  --md-text-button-with-trailing-icon-leading-space: var(--pgm-button-leading-space);
  --md-text-button-with-trailing-icon-trailing-space: var(--pgm-button-trailing-space);
}

.buttonElevated {
  --md-elevated-button-container-color: var(
    --pgm-sys-color-surface-container-low
  );
  --md-elevated-button-label-text-color: var(--pgm-sys-color-primary);
  --md-elevated-button-icon-color: var(--pgm-sys-color-primary);
  --md-elevated-button-hover-label-text-color: var(--pgm-sys-color-primary);
  --md-elevated-button-hover-icon-color: var(--pgm-sys-color-primary);
  --md-elevated-button-hover-state-layer-color: var(--pgm-sys-color-primary);
  --md-elevated-button-focus-label-text-color: var(--pgm-sys-color-primary);
  --md-elevated-button-focus-icon-color: var(--pgm-sys-color-primary);
  --md-elevated-button-pressed-label-text-color: var(--pgm-sys-color-primary);
  --md-elevated-button-pressed-icon-color: var(--pgm-sys-color-primary);
  --md-elevated-button-pressed-state-layer-color: var(--pgm-sys-color-primary);
}

.buttonFilled {
  --md-filled-button-container-color: var(--pgm-sys-color-primary);
  --md-filled-button-label-text-color: var(--pgm-sys-color-on-primary);
  --md-filled-button-icon-color: var(--pgm-sys-color-on-primary);
  --md-filled-button-hover-label-text-color: var(--pgm-sys-color-on-primary);
  --md-filled-button-hover-icon-color: var(--pgm-sys-color-on-primary);
  --md-filled-button-hover-state-layer-color: var(--pgm-sys-color-on-primary);
  --md-filled-button-focus-label-text-color: var(--pgm-sys-color-on-primary);
  --md-filled-button-focus-icon-color: var(--pgm-sys-color-on-primary);
  --md-filled-button-pressed-label-text-color: var(--pgm-sys-color-on-primary);
  --md-filled-button-pressed-icon-color: var(--pgm-sys-color-on-primary);
  --md-filled-button-pressed-state-layer-color: var(--pgm-sys-color-on-primary);
}

.buttonTonal {
  --md-filled-tonal-button-container-color: var(--pgm-sys-color-secondary-container);
  --md-filled-tonal-button-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-icon-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-hover-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-hover-icon-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-hover-state-layer-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-focus-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-focus-icon-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-pressed-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-pressed-icon-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-pressed-state-layer-color: var(--pgm-sys-color-on-secondary-container);
}

.buttonOutlined {
  --md-outlined-button-outline-color: var(--pgm-sys-color-outline-variant);
  --md-outlined-button-label-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-button-hover-label-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-button-hover-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-button-focus-label-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-button-pressed-label-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-button-pressed-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-button-pressed-outline-color: var(--pgm-sys-color-outline-variant);
  --md-outlined-button-pressed-state-layer-color: var(--pgm-sys-color-on-surface-variant);
}

.buttonText {
  --md-text-button-label-text-color: var(--pgm-sys-color-primary);
  --md-text-button-icon-color: var(--pgm-sys-color-primary);
  --md-text-button-hover-label-text-color: var(--pgm-sys-color-primary);
  --md-text-button-hover-icon-color: var(--pgm-sys-color-primary);
  --md-text-button-hover-state-layer-color: var(--pgm-sys-color-primary);
  --md-text-button-focus-label-text-color: var(--pgm-sys-color-primary);
  --md-text-button-focus-icon-color: var(--pgm-sys-color-primary);
  --md-text-button-pressed-label-text-color: var(--pgm-sys-color-primary);
  --md-text-button-pressed-icon-color: var(--pgm-sys-color-primary);
  --md-text-button-pressed-state-layer-color: var(--pgm-sys-color-primary);
}

.buttonTrailingIcon {
  color: currentColor;
  display: inline-flex;
  fill: currentColor;
  flex: 0 0 var(--pgm-button-icon-size);
  font-size: var(--pgm-button-icon-size);
  height: var(--pgm-button-icon-size);
  margin-inline-start: var(--pgm-button-icon-label-space);
  vertical-align: middle;
  width: var(--pgm-button-icon-size);
}

.iconButton {
  --pgm-icon-button-shape-full: 9999px;
  --pgm-icon-button-size: 40px;
  --pgm-icon-button-icon-size: 24px;
  --md-icon-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-icon-size: var(--pgm-icon-button-icon-size);
  --md-icon-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-pressed-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-pressed-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-state-layer-height: var(--pgm-icon-button-size);
  --md-icon-button-state-layer-shape: var(--pgm-icon-button-shape-full);
  --md-icon-button-state-layer-width: var(--pgm-icon-button-size);
  --md-filled-icon-button-container-height: var(--pgm-icon-button-size);
  --md-filled-icon-button-container-shape: var(--pgm-icon-button-shape-full);
  --md-filled-icon-button-container-width: var(--pgm-icon-button-size);
  --md-filled-icon-button-icon-size: var(--pgm-icon-button-icon-size);
  --md-filled-tonal-icon-button-container-height: var(--pgm-icon-button-size);
  --md-filled-tonal-icon-button-container-shape: var(--pgm-icon-button-shape-full);
  --md-filled-tonal-icon-button-container-width: var(--pgm-icon-button-size);
  --md-filled-tonal-icon-button-icon-size: var(--pgm-icon-button-icon-size);
  --md-outlined-icon-button-container-height: var(--pgm-icon-button-size);
  --md-outlined-icon-button-container-shape: var(--pgm-icon-button-shape-full);
  --md-outlined-icon-button-container-width: var(--pgm-icon-button-size);
  --md-outlined-icon-button-icon-size: var(--pgm-icon-button-icon-size);

  aspect-ratio: 1;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 var(--pgm-icon-button-size);
  height: var(--pgm-icon-button-size);
  max-height: var(--pgm-icon-button-size);
  max-width: var(--pgm-icon-button-size);
  min-height: var(--pgm-icon-button-size);
  min-width: var(--pgm-icon-button-size);
  vertical-align: middle;
  width: var(--pgm-icon-button-size);
}

.iconButtonExtraSmall {
  --pgm-icon-button-size: 32px;
  --pgm-icon-button-icon-size: 20px;
}

.iconButtonSmall {
  --pgm-icon-button-size: 40px;
  --pgm-icon-button-icon-size: 24px;
}

.iconButtonMedium {
  --pgm-icon-button-size: 56px;
  --pgm-icon-button-icon-size: 24px;
}

.iconButtonLarge {
  --pgm-icon-button-size: 96px;
  --pgm-icon-button-icon-size: 32px;
}

.iconButtonExtraLarge {
  --pgm-icon-button-size: 136px;
  --pgm-icon-button-icon-size: 40px;
}

.iconButton:hover:not([disabled]):not([soft-disabled]) {
  --md-icon-button-state-layer-shape: var(--pgm-icon-button-shape-full);
  --md-filled-icon-button-container-shape: var(--pgm-icon-button-shape-full);
  --md-filled-tonal-icon-button-container-shape: var(--pgm-icon-button-shape-full);
  --md-outlined-icon-button-container-shape: var(--pgm-icon-button-shape-full);
}

.iconButton:active:not([disabled]):not([soft-disabled]) {
  --md-icon-button-state-layer-shape: 8px;
  --md-filled-icon-button-container-shape: 8px;
  --md-filled-tonal-icon-button-container-shape: 8px;
  --md-outlined-icon-button-container-shape: 8px;
}

.iconButtonIcon {
  display: block;
  font-size: var(--pgm-icon-button-icon-size);
  height: var(--pgm-icon-button-icon-size);
  line-height: var(--pgm-icon-button-icon-size);
  width: var(--pgm-icon-button-icon-size);
}
